import Vue from "vue";
import Vuex from "vuex";
import Auth from "./modules/auth/store";
import Roles from "./modules/roles/store";
import Modules from "./modules/rolemodules/store";
import Permissions from "./modules/permissions/store";
import Users from "./modules/users/store";
import UserRoles from "./modules/userroles/store";
import userProfile from "./modules/userprofile/store";
import customers from "./modules/customers/store";
import importers from "./modules/importers/store";
import shippinglines from "./modules/shippinglines/store";
import transporters from "./modules/transporters/store";
import files from "./modules/fileopenings/store";
import cargoentries from "./modules/cargoentries/store";
import shippings from "./modules/shippings/store";
import customreleases from "./modules/customreleases/store";
import tarrifs from "./modules/tarrifs/store";
import trucks from "./modules/trucks/store";
import bonds from "./modules/bonds/store";
import requisitions from "./modules/requisitions/store";
import bondtrackings from "./modules/bondtrackings/store";
import trucktrackings from "./modules/trucktrackings/store";
import interchanges from "./modules/interchanges/store";
import pettycashes from "./modules/pettycashes/store";
import reports from "./modules/reports/store";
import dailytransactions from "./modules/dailytransactions/store";
import accounttypes from "./modules/accounttypes/store";
import pettyaccounts from "./modules/pettyaccounts/store";
import invoices from "./modules/invoices/store";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Auth,
    Roles,
    Modules,
    Permissions,
    Users,
    UserRoles,
    userProfile,
    customers,
    importers,
    shippinglines,
    transporters,
    files,
    cargoentries,
    shippings,
    customreleases,
    tarrifs,
    trucks,
    bonds,
    requisitions,
    bondtrackings,
    trucktrackings,
    interchanges,
    reports,
    pettycashes,
    dailytransactions,
    accounttypes,
    pettyaccounts,
    invoices
  }
});



// WEBPACK FOOTER //
// ./src/vuex/store.js